import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
export const CopyRight = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Traversal._filteredOn(Optics._Col2ComponentId, (id) => id === "copyright"), Res._Response(), Lens.path("attributes", "title"), M._Just());

